module.exports = __webpack_public_path__ + "img/companyIntro6.1da80864.png";